
<template>
    <div class="center">
        <editar v-model="activeEditar" :selectInfo="selectInfo" :ciclosEscolaresArray="ciclosEscolaresArray" :institucionesArray="institucionesArray" @refreshTable="getRefresh"></editar>
        <vs-table>
            <template #thead>
                <vs-tr>
                    <vs-th width="150px">
                        Método descuento
                    </vs-th>
                    <vs-th width="150px">
                        Descuento
                    </vs-th>
                    <vs-th>
                        Fecha de apertura
                    </vs-th>
                    <vs-th>
                        Fecha cierre
                    </vs-th>
                    <vs-th width="150px">
                        Abonos
                    </vs-th>
                    <vs-th width="150px">
                        Cargos
                    </vs-th>
                    <vs-th>
                        Acciones
                    </vs-th>
                </vs-tr>
            </template>
            <template #tbody>
                <vs-tr
                    :key="i"
                    v-for="(tr, i) in filterRegs"
                    :data="tr"
                >
                    <vs-td>
                        <div class="d-flex">
                            <vs-avatar circle :color="categoriasColores[tr.metodo_descuento]['color']" >
                                <template #text>
                                {{ categoriasColores[tr.metodo_descuento]['abv'] }}
                                </template>
                            </vs-avatar>
                            <div class="d-flex align-items-center">
                                 <span class="text-uppercase ml-2 fs-14 text-dark">{{tr.metodo_descuento}}</span>
                            </div>
                        </div>
                    </vs-td>
                    <vs-td>
                        <strong class="fs-14 text-dark">{{ tr.metodo_descuento =='porcentaje' ? tr.porcentaje+'%': '$'+tr.monto }}</strong>
                        <p class="text-muted fs-14">{{ tr.programa ? tr.programa.nombre : tr.nivel_academico ? tr.nivel_academico.nivel : '' }}</p>
                    </vs-td>
                    <vs-td>
                        <span class="fs-14 text-dark"><i class="far fa-calendar"></i>
                        {{ tr.fecha_apertura }}</span>
                    </vs-td>
                    <vs-td>
                        <span class="fs-14 text-dark"><i class="far fa-calendar"></i>
                        {{ tr.fecha_cierre }}</span>
                    </vs-td>
                    <vs-td>
                        <strong class="fs-14 text-dark">{{ tr.abonos.nombre }}</strong><br>
                        <span class="fs-14">{{ tr.abonos.clave }} {{ 'gravable: '+ tr.abonos.gravable }}</span>
                    </vs-td>
                    <vs-td>
                        <strong class="fs-14 text-dark">{{ tr.cargos.nombre }}</strong><br>
                        <span class="fs-14">{{ tr.cargos.clave }} {{ 'gravable: '+ tr.cargos.gravable }}</span>
                    </vs-td>
                    <vs-td>
                        <vs-button
                            icon
                            color="success"
                            flat
                            @click="activeEditar =! activeEditar, selectInfo = tr"
                        >
                            <i class="far fa-edit"></i>
                        </vs-button>
                    </vs-td>
                </vs-tr>
            </template>
            <template #notFound>
                Sin información
            </template>

        </vs-table>
    </div>
</template>
<script>
import editar from './modal/editar.vue'
export default {
    props: [
        'regs',
        'ciclosEscolaresArray',
        'institucionesArray',
        'filter'
    ],
    data:() => ({
        search: '',
        activeEditar: false,
        activeEliminar: false,
        selectInfo: [],
        categoriasColores: {
            "porcentaje" : {
                "color" : "#5dade2",
                "abv" : "P"
            },
            "monto" : {
                "color" : "#f39c12",
                "abv" : "M"
            },
            "servicio" : {
                "color" : "purple",
                "abv" : "S"
            },
        },
    }),
    components: {
        editar,
    },
    methods:{
        getRefresh(){
            this.$emit('refreshTable')
        },
        getColor(metodo){
            if(metodo == 'servicio'){
                return 'bpill--servicio'
            }
            if(metodo == 'porcentaje'){
                return 'bpill--porcentaje'
            }
            if(metodo == 'monto'){
                return 'bpill--monto'
            }

        },
    },
    computed: {
        filterRegs() {
            if (this.filter) {
                return this.regs.filter(reg => {
                    const filterBy = [
                        reg.metodo_descuento,
                        reg.porcentaje || 0,
                        reg.monto || 0,
                        reg.fecha_apertura,
                        reg.fecha_cierre,
                        reg.abonos.nombre,
                        reg.cargos.nombre
                    ];

                    const sfilterBy = filterBy.map(x => x.toString().toLowerCase());

                    return sfilterBy.some(camp => camp.includes(this.filter.toLowerCase()));
                });
            }

            return this.regs;
        }
    },
}
</script>
<style lang="scss" scoped>
.fs-14 {
    font-size: 14px;
}
.figma-table {
    .bpill {
        color: white;
        width: 40px;
        height: 40px;
        flex-shrink: 0;
    }

    .bpill--servicio {
        background-color: purple;
    }

    .bpill--porcentaje {
        background-color: #5dade2;
    }

    .bpill--monto {
        background-color: #f39c12;
    }

    thead th {
        padding: 20px;
    }

    thead th:first-child {
        border-top-left-radius: 20px;
        width: 180px;
    }

    thead th:nth-child(2) {
        width: 320px;
    }

    thead th:last-child {
        border-top-right-radius: 20px;
    }

    .apill {
        min-width: 150px;
    }

    .apill--reingreso {
        background-color: #baece6;
        color: #16beaa;
    }

    .apill--ingreso {
        background-color: #ffeed4;
        color: #ffa928;
    }

    .fbutton {
        border: none;
        width: 35px;
        height: 35px;
    }

    .fbutton--edit {
        background-color: #e3f7e2;
        color: #65cd65;
    }

    .fbutton--delete {
        background-color: #ffe4e6;
        color: #ff4757;
    }
}
</style>


        